<template>
  <div>
    <store-header :swiperList="swiperList" :headerInfo="headerInfo" :introduceInfo="introduceInfo" v-transition></store-header>
  </div>
</template>

<script>
import storeHeader from './components/Header'
export default {
  name: 'Store',
  components: {
    storeHeader
  },
  data () {
    return {
      headerInfo: {},
      introduceInfo: {},
      swiperList: [],
      shopid: decodeURIComponent(this.$route.query.shopid),
      shopstate: false
    }
  },
  methods: {
    getStoreState () {
      this.axios.get('/ApiStore/VerifyStore?id=' + this.shopid)
        .then(this.getStoreStateSucc)
        .catch(this.getStoreStateFail)
    },
    getStoreStateSucc (res) {
      res = res.data
      if (res.ret && res.data) {
        const data = res.data
        this.shopstate = data.isPass
        if (this.shopstate === 'True') {
          this.getStorInfo()
        } else {
          this.$router.push({
            path: '/error'
          })
        }
      }
    },
    getStoreStateFail (err) {
      console.log(err)
    },
    getStorInfo () {
      this.axios.get('/ApiStore/GetModel', {
        params: {
          id: this.shopid
        }
      }).then(this.getStorInfoSucc)
        .catch(this.getStorInfoFail)
    },
    getStorInfoSucc (res) {
      res = res.data
      if (res.ret && res.data) {
        const data = res.data
        this.swiperList = JSON.parse(data.slideList)
        this.headerInfo = JSON.parse(data.headerList)[0]
        this.introduceInfo = JSON.parse(data.introduceList)[0]
      }
    },
    getStorInfoFail (err) {
      console.log(err)
    }
  },
  created () {
    this.getStoreState()
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/my_store/Store.vue